export const FETCH_PROVIDER_BY_ID = (id: number) => `/providers/${id}`;
export const FETCH_ANALYSIS_BY_ID = (id: number) => `/providers/${id}/analysis`;
export const GENERATE_PDF = (id: number) => `/pdf/${id}`;
// export const FETCH_CHARTDATA = `/schemes/analysis/basic`;
export const FETCH_CHARTDATA = (id: number) => `/pdf/reports/data/${id}`;
